<mat-card class="subcollection-card">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-title>{{ title }}</mat-card-title>

        <div class="actions">
            <button *ngIf="canCreate()" mat-icon-button color="primary" (click)="clickItemAdd()">
                <mat-icon aria-label="Item toevoegen">add</mat-icon>
            </button>
        </div>
    </mat-card-header>

    <mat-card-content>
        <ng-content></ng-content>
    </mat-card-content>
</mat-card>